import { ICONS, DataItemFormatter } from '@creditsights/styleguide-web';
import classNames from 'classnames/bind';
import React, { ReactElement } from 'react';
import ActionButton from '../../ActionButton';
import styles from './ActionCellRenderer.module.scss';

interface ActionCellRendererProps {
  onEdit: Function;
  editButtonTooltip?: string;
  showEditAction?: (item) => boolean;
}

const cx = classNames.bind(styles);

const ActionCellRenderer: DataItemFormatter<unknown, ReactElement, ActionCellRendererProps> = ({
  props,
  row,
  item,
}) => {
  const { index } = row;
  const showEditAction = props?.showEditAction?.(item) ?? true;
  const onEdit = () => {
    props?.onEdit(index, item);
  };

  return (
    <div className={cx('body')}>
      {showEditAction && (
        <ActionButton
          icon={ICONS.Edit}
          onClick={onEdit}
          tooltip={props?.editButtonTooltip ? props.editButtonTooltip : 'Edit'}
          dataTestId="action-cell-edit-button"
          ariaLabel="Edit"
        />
      )}
    </div>
  );
};

export default ActionCellRenderer;
